import React, { useEffect, useId } from 'react';
import { X } from 'lucide-react';
import Button from './Button';

const SIZE_WIDTHS = {
  sm: '420px',
  md: '520px',
  lg: '680px',
  xl: '840px',
  full: '1040px',
};

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  showCloseButton = true,
  hideHeader = false,
}) => {
  const titleId = useId();

  // Close on escape key
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevent body scroll while the modal is open
  useEffect(() => {
    if (!isOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal modal-${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={hideHeader ? undefined : titleId}
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: SIZE_WIDTHS[size] || SIZE_WIDTHS.md }}
      >
        {!hideHeader && (
          <div className="modal-header">
            <h2 className="modal-title" id={titleId}>
              {title}
            </h2>
            {showCloseButton && (
              <Button
                variant="ghost"
                size="sm"
                icon={<X size={18} />}
                onClick={onClose}
                aria-label="Close modal"
              />
            )}
          </div>
        )}
        <div className={`modal-body ${hideHeader ? 'no-header' : ''}`}>{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
